import { platform } from "./@native/platform";

const OPEN_BROWSER = "openBrowser";

/** 새창 열기 브릿지 */
export const openBrowser = (url: string) => {
  switch (platform) {
    case "android":
      try {
        window.Becon.requestAction(OPEN_BROWSER, "1", JSON.stringify({ url }));
      } catch (err) {
        console.error(`android error -> ${err}`);
      }
      break;
    case "ios":
      try {
        window.webkit.messageHandlers.openBrowser.postMessage(JSON.stringify({ url }));
      } catch (err) {
        console.error(`ios error -> ${err}`);
      }
      break;
    case "web":
      try {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.click();
        a.remove();
      } catch (err) {
        console.error(`web error -> ${err}`);
      }
      break;
  }
};
